import { useState } from 'react';
import { DeleteOutlined, PlusOutlined } from '@ant-design/icons';
import { Button, Checkbox, Form, Input, Layout, Modal, Space, Spin, Switch, Table } from 'antd';

import { FeatureFlags, PageLayout, Tables, Theme } from '@app/web-components';

export const LandingPage = () => {
  const { token } = Theme.useToken();
  const { parentRef, toolbarRef, getTableHeight } = Tables.useReactiveTableHeight();

  const [form] = Form.useForm();

  const { data, isPending } = FeatureFlags.useFindFeatureFlags({ orderBy: { key: 'asc' } });
  const create = FeatureFlags.useCreateFeatureFlag();
  const edit = FeatureFlags.useUpdateFeatureFlag();
  const remove = FeatureFlags.useDeleteFeatureFlag();

  const [open, setOpen] = useState(false);

  if (isPending) {
    return <Spin />;
  }

  const onCancel = () => {
    setOpen(false);
    form.resetFields();
  };

  const onFinish = (data: { key: string; description: string; isEnabled: boolean }) => {
    create.mutate(data);
    onCancel();
  };

  return (
    <>
      <Modal open={open} onCancel={onCancel} onOk={() => form.submit()}>
        <Form
          form={form}
          initialValues={{ key: '', description: '', isEnabled: false }}
          layout="vertical"
          onFinish={onFinish}
        >
          <Form.Item label="Key" name="key" required rules={[{ required: true }]}>
            <Input />
          </Form.Item>
          <Form.Item label="Description" name="description" required rules={[{ required: true }]}>
            <Input />
          </Form.Item>
          <Form.Item label="Enabled" name="isEnabled" valuePropName="checked">
            <Checkbox />
          </Form.Item>
        </Form>
      </Modal>
      <Layout.Content
        ref={parentRef}
        style={{
          paddingTop: 24,
          paddingLeft: 24,
          paddingRight: 24,
          margin: 0,
          height: '100%',
          minHeight: 0,
          background: token.colorBgContainer,
          overflow: 'auto',
        }}
      >
        <PageLayout.Title title="Feature Flags" />
        <div style={{ width: '100%' }} ref={toolbarRef}>
          <Space style={{ marginBottom: 20 }} wrap>
            <Button icon={<PlusOutlined />} type="primary" onClick={() => setOpen((oldValue) => !oldValue)}>
              New Feature Flag
            </Button>
          </Space>
        </div>
        <Table
          size="small"
          columns={[
            {
              title: 'Feature Key',
              dataIndex: 'key',
            },
            { title: 'Description', dataIndex: 'description' },
            {
              title: 'Enabled',
              dataIndex: 'isEnabled',
              render: (isEnabled: boolean, record) => (
                <Switch
                  size="small"
                  checked={isEnabled}
                  onChange={(newValue) =>
                    edit.mutate({
                      key: encodeURIComponent(record.key),
                      isEnabled: newValue,
                      description: record.description,
                    })
                  }
                />
              ),
            },
            {
              title: 'Delete',
              dataIndex: 'key',
              render: (key) => (
                <Button size="small" icon={<DeleteOutlined />} onClick={() => remove.mutate(encodeURIComponent(key))}>
                  Delete
                </Button>
              ),
            },
          ]}
          dataSource={data}
          scroll={{ y: getTableHeight() }}
        />
      </Layout.Content>
    </>
  );
};
